import { MyPageGiftOwnedGetInputModel } from "../../api/v1/mypage/gift/owned/GetInputModel"
import { getMyPageGiftOwned } from "../../api/v1/mypage/gift/owned/get"
import { adaptGiftItem } from "./adaptGiftItem"
import { GiftItem } from "./GiftItem"
import { GIFT_TYPE_DEFINITIONS } from "./GIFT_TYPE_DEFINITIONS"

// 数量0件のものも含めて、所有ギフトを返す
export const fetchOwedGiftItems = async (): Promise<GiftItem[]> => {
  const model = new MyPageGiftOwnedGetInputModel()

  const itemsResponse = await getMyPageGiftOwned(model).then((v) => v.results)

  return GIFT_TYPE_DEFINITIONS.map((def) => {
    const found = itemsResponse.find((v) => v.gift_item_id === def.id)
    if (!found) {
      return {
        type: def,
        amount: 0,
      }
    }

    return adaptGiftItem(found)
  })
}
